import useModal from 'hook/useModal'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import groupBy from 'utils/group-by'

import { useRecoilValue } from 'recoil'
import { siteListState, userInfoState } from 'store/atom/user-state-atom'

// components
import { BottomButton, Breadcrumb, Label, SelectOption, TextInput } from 'components'

import { useGoodsAplcDtl, useGoodsAplcDtRegist } from 'api/head/headpreorder-fetch'
import { format, parse } from 'date-fns'
import { queryClient } from 'index'
import { formatStringDate } from 'utils/format-util'

// css
import 'assets/style/common.scss'
import 'assets/style/elements/hash-tag.scss'
import { isEmptyString } from 'utils/common-util'

/**
 * 입고가능일 일자세팅
 */
const generateOptions = (startDate, dateDiff, enterDt) => {
  const options = []
  options.push({ id: 'S', text: '선택' }, { id: '', text: '신청 안함' })

  const temp = Array.from({ length: parseInt(dateDiff) + 1 }).map((_, i) => {
    const date = new Date(startDate)
    date.setDate(date.getDate() + i)
    const formattedDate = format(date, 'yyyy-MM-dd')
    return {
      id: formattedDate,
      text: formattedDate,
    }
  })
  return [...options, ...temp]
}
///api/head/preprdreq/v1.0/insertGoodsAplctDtl
function PreOrderReg({ ntcAtclId }) {
  const [isInit, setIsInit] = useState(false)
  const { alertModal, confirmModal, closeModal, closeModalAll } = useModal()

  const userInfo = useRecoilValue(userInfoState)
  const siteList = useRecoilValue(siteListState)

  const formDefaultVal = {}
  const [siteIds, setSiteIds] = useState([])
  const { isSuccess, data } = useGoodsAplcDtl(
    {
      ntcAtclId,
      lgsCntrId: userInfo.lgsCtrId,
      coId: userInfo.coId,
      shpId: userInfo.shpId,
    },
    isInit,
  )

  const { register, handleSubmit, reset, control, watch, getValues, setValue } = useForm({
    defaultValues: formDefaultVal,
  })

  useEffect(() => {
    setIsInit(true)
    return () => {
      queryClient.removeQueries('selectGoodsAplctDtl')
    }
  }, [])

  useEffect(() => {
    if (data) {
      load()
    }
  }, [isSuccess])

  const shpId = userInfo.shpId
  const load = () => {
    // const sameSite = data?.goodsListDetlData.some((objA) =>
    //   siteList.filter((fSite) => fSite.siteId.startsWith(shpId)).some((objB) => objA.siteId === objB.siteId),
    // )
    // const tmpGoodsList = sameSite
    //   ? data?.goodsListDetlData
    //       ?.filter((fSite) => fSite.siteId.startsWith(shpId))
    //       ?.map((good) => {
    //         let enterDt = good.enterDt
    //         const tEnterDt = parse(enterDt, 'yyyy-MM-dd', new Date())
    //         if (isNaN(tEnterDt)) {
    //           enterDt = ''
    //         }

    //         good.enterDt = enterDt
    //         good.rmrk = good.rmrk === null ? '' : good.rmrk
    //         good.odrCqty = Number(good.odrCqty || 0).toFixed(0)

    //         if (!good.siteId) {
    //           return siteList
    //             .filter((fSite) => fSite.siteId.startsWith(shpId))
    //             .map((site) => ({
    //               ...good,
    //               siteId: site.siteId,
    //               siteNm: site.siteNm,
    //             }))
    //         }

    //         if (good.siteId && !good.siteNm) {
    //           const siteNm = siteList.filter((site) => site.siteId === good.siteId)[0]?.siteNm
    //           return { ...good, siteNm: siteNm }
    //         }
    //       })
    //   : data?.goodsListDetlData
    //       .filter((thing, index, self) => index === self.findIndex((t) => t.goodsNo === thing.goodsNo))
    //       .map((good) => {
    //         return siteList
    //           .filter((fSite) => fSite.siteId.startsWith(shpId))
    //           .map((site) => ({
    //             ntcAtclId: good.ntcAtclId,
    //             coId: good.coId,
    //             lgsCnteId: site.lgsCtrId,
    //             lgsCnteNm: site.lgsCtrNm,
    //             siteId: site.siteId,
    //             siteNm: site.siteNm,
    //             goodsNo: good.goodsNo,
    //             gdNm: good.gdNm,
    //             gdBd: good.gdBd,
    //             ordrUnitCd: good.ordrUnitCd,
    //             enterPsbtStartDt: good.enterPsbtStartDt,
    //             enterPsbtTmntDt: good.enterPsbtTmntDt,
    //             dateDiff: good.dateDiff,
    //             odrCqty: 0,
    //             enterDt: 'S',
    //             rmrk: null,
    //             regrId: userInfo.userId,
    //           }))
    //       })

    // const newGoodsList = []
    //   .concat(...tmpGoodsList)
    //   .sort((a, b) => {
    //     const aSiteId = a.siteId.toUpperCase()
    //     const bSiteId = b.siteId.toUpperCase()
    //     if (aSiteId < bSiteId) return -1
    //     else if (aSiteId > bSiteId) return 1
    //     return 0
    //   })
    //   .filter((objA) =>
    //     siteList.filter((fSite) => fSite.siteId.startsWith(shpId)).some((objB) => objA.siteId === objB.siteId),
    //   )
    // // setOrderData()
    // const groupBySiteId = groupBy(newGoodsList, 'siteId', 'siteNm')
    // const siteIds = []
    // for (const [key, value] of Object.entries(groupBySiteId)) {
    //   // lgsCntIds.push(key)
    //   siteIds.push(groupBySiteId[key])
    //   setValue(key, value.data)
    // }
    // console.log(siteIds)
    // setSiteIds(siteIds)

    const tempData = data?.goodsListDetlData.map((good) => {
      let enterDt = good.enterDt

      if (enterDt === null) {
        enterDt = 'S'
      } else if (enterDt.trim() === '') {
        enterDt = ''
      } else {
        const tEnterDt = formatStringDate(enterDt, '-')

        if (tEnterDt === '') {
          enterDt = ''
        } else {
          enterDt = tEnterDt
        }
      }

      good.enterDt = enterDt
      good.rmrk = good.rmrk === null ? '' : good.rmrk
      good.odrCqty = Number(good.odrCqty || 0).toFixed(0)
      return good
    })
    console.log(tempData)
    const groupBySiteId = groupBy(tempData, 'siteId', 'siteNm')
    const siteIds = []
    for (const [key, value] of Object.entries(groupBySiteId)) {
      // lgsCntIds.push(key)
      siteIds.push(groupBySiteId[key])
      setValue(key, value.data)
    }
    console.log(siteIds)
    setSiteIds(siteIds)
  }

  const goodsAplcDtRegist = useGoodsAplcDtRegist({
    successHandler: () => {
      alertModal('저장이 완료되었습니다.', closeModalAll)
    },
    errorHandler: () => {},
  })

  const onValid = (data) => {
    console.log(data)
    const out = []
    let inDateCnt = 0
    let qtyCnt = 0
    for (const siteId of siteIds) {
      for (const item of data[siteId.siteId]) {
        console.log('## ' + item.enterDt + ' ##')
        console.log('## ' + item.odrCqty + ' ##')
        // 공백확인
        if (item.enterDt === 'S') {
          inDateCnt++
        }

        if (item.enterDt !== 'S' && item.enterDt !== '' && (isNaN(item.odrCqty) || parseInt(item.odrCqty) === 0)) {
          qtyCnt++
        }

        item.regrId = userInfo.userId

        out.push(item)
      }
    }

    if (inDateCnt > 0) {
      alertModal('입고가능일을 선택해주세요.')
      return
    }
    if (qtyCnt > 0) {
      alertModal('주문수량을 입력해주세요.')
      return
    }

    confirmModal('저장하시겠습니까?', () => {
      closeModal()
      goodsAplcDtRegist.mutate(out)
    })
  }

  const resetButton = () => {
    confirmModal('초기화 하시겠습니까?', () => {
      closeModal()
      reset()
      load()
    })
  }

  return (
    <main>
      {/* todo: 팝업 헤더 */}
      <div className="wrapper" style={{ marginBottom: '64px' }}>
        {/* 첫번째 아코디언 */}
        <ul className="accordion-menu mt16">
          {siteIds.map((site, index1) => (
            <li key={index1}>
              <div className="accordion-head title-border-box">
                <Breadcrumb data={[`[${site.siteId}] ${site.siteNm}`]} />
              </div>
              <div className="accordion-body">
                <ul className="vertical-form-group mt16 row-gap-10">
                  {site.data?.map((item, index2) => (
                    <li key={`${index1}_${index2}`}>
                      <Label text={`[${item.goodsNo}] ${item.gdBd}`} />
                      <SelectOption
                        className="input-select block arrow mb8"
                        textKey="text"
                        valueKey="id"
                        list={generateOptions(item.enterPsbtStartDt, item.dateDiff, item.enterDt)}
                        register={register(`${site.siteId}[${index2}].enterDt`, {
                          onChange: (e) => {
                            if (e.target.value === 'S' || e.target.value === '') {
                              setValue(`${site.siteId}[${index2}].odrCqty`, 0)
                              setValue(`${site.siteId}[${index2}].rmrk`, '')
                            }
                          },
                        })}
                      />
                      <Controller
                        control={control}
                        name={`${site.siteId}[${index2}].odrCqty`}
                        render={({ field }) => (
                          <TextInput
                            placeholder="주문수량"
                            disabled={watch(`${site.siteId}[${index2}].enterDt`) === ''}
                            type="number"
                            register={field}
                          />
                        )}
                      />
                      <Controller
                        control={control}
                        name={`${site.siteId}[${index2}].rmrk`}
                        render={({ field }) => (
                          <TextInput placeholder="비고를 입력 하세요" className="mt8" register={field} />
                        )}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>

        <BottomButton
          data={[
            { id: false, title: '초기화', color: 'black' },
            { id: true, title: '저장', color: 'primary' },
          ]}
          onClick={({ id }) => {
            if (id) {
              handleSubmit(onValid)()
            } else resetButton()
          }}
        />
      </div>
    </main>
  )
}

export default PreOrderReg
